export default "__VITE_ASSET__BxNKHGiz__"